import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectAny = ({
  collection,
  field,
  className,
  value,
  onChange,
  placeholder,
  ...props
}) => {
  const { data, isLoading, isError } = useFetch({
    queryKey: [collection, field],
    queryFn: async () => {
      const response = await getDirectusField(collection, field);

      const data = response.meta.options.choices.map((choice) => {
        return { name: choice.text, id: choice.value };
      });

      return data;
    },
    enabled: !!collection && !!field,
  });

  return (
    <EvtSelect
      data={data}
      isLoading={isLoading}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="filter"
      {...props}
    />
  );
};

export default SelectAny;
